import StrongRecipeNotificationModal from './StrongRecipeNotificationModal';

export default StrongRecipeNotificationModal;
